export const logout = () => {
  localStorage.removeItem("staff");
  window.location.assign('/');
};

export const getCurrentStaff = () => {
  return JSON.parse(localStorage.getItem("staff"));
};
